export const mergeItemsSources = (itemsMenusFlat = [], customItems = [], articlesById = {}) => {
  const all = [...itemsMenusFlat, ...customItems];
  const map = {};

  for (const it of all) {
    const id = it.articleId;
    if (!id) continue;

    if (!map[id]) {
      map[id] = {
        articleId: id,
        name: it.name || articlesById[id]?.name || "Sans nom",
        unit: it.unit || articlesById[id]?.unit || "",
        categorie: it.categorie || articlesById[id]?.categorie || null,
        source: it.source,  
        totalQuantity: 0,
        details: []
      };
    }

    // 👇 FIX CRITIQUE : si un item custom existe, la source doit rester custom
    if (it.source === "custom") {
      map[id].source = "custom";
    }

    // Si une catégorie plus précise arrive, on la garde
    if (!map[id].categorie && it.categorie) {
      map[id].categorie = it.categorie;
    }

    const qty = Number(it.quantity) || 0;
    map[id].totalQuantity += qty;

    map[id].details.push({
      date: it.date,
      moment: it.moment,
      quantity: qty,
      categorie: it.categorie
    });
  }

  return Object.values(map);
};
